export default __webpack_public_path__ + "static/media/b2.2b15decd.png";